import { LoanCategory } from '../../../../../../../../../../types/api';
import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';
import { NON_PROFIT_ORGANIZATION_TYPES } from '../../../../../../../constants';

const { loanCategory, nonProfitOrganizationType } = loanFormModel.formField;

class IsFBO implements Rule {
  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const category = application[loanCategory.name] as LoanCategory | null;
    const nonProfitType = application[nonProfitOrganizationType.name];
    return (
      category !== null &&
      category !== undefined &&
      (category == LoanCategory.NPO_FBO ||
        nonProfitType == NON_PROFIT_ORGANIZATION_TYPES.FBO)
    );
  }
}

export default new IsFBO();
